<template>
  <div>
    <div class="header-main">
      <h1 class="py-4 page-title-main">
        <slot name="title" />
      </h1>
    </div>
    <template>
      <div class="px-main">
        <v-tabs v-model="tab" class="t-tab-custom">
          <v-tab v-for="(item, i) in items" :key="i" :to="item.to">{{
            item.title
          }}</v-tab>
        </v-tabs>
      <slot name="default" />
      </div>
    </template>
  </div>
</template>

<script>
import { checkPermissionTab } from '@/utils/permissions'

export default {
  name: 'BaseFrameSetting',
  data () {
    return {
      tab: null,
      items: [],
      itemsTmp: [
        {
          title: this.$t('routeTitles.frameSetting.frameSettingCalendar'),
          to: '/frame-setting/calendar',
          pathRoot: '/frame-setting/calendar',
          order: 1
        },
        {
          title: this.$t('routeTitles.frameSetting.systemOuterLimitSetting'),
          to: '/frame-setting/system-outer',
          pathRoot: '/frame-setting/system-outer',
          order: 2
        }
      ]
    }
  },
  mounted () {
    this.checkPerTab()
  },
  methods: {
    checkPermissionTab,
    checkPerTab () {
      let itemCheck = this.checkPermissionTab(this.itemsTmp)
      itemCheck = [...new Set(itemCheck)]
      itemCheck.sort((a, b) => a.order - b.order)
      this.items = itemCheck
    }
  }
}
</script>

<style lang="scss">

</style>
